/**
 * Static content for the four firm policy pages.
 * Source of truth — referenced by LegalPage.jsx via slug.
 *
 * Slugs match the public routes: refund-policy, ai-disclaimer,
 * confidentiality-policy, payment-policy.
 */
const updated = "16 فبراير 2026";
const updatedEn = "February 16, 2026";

export const LEGAL_PAGES = {
  "refund-policy": {
    titleAr: "سياسة الاسترداد",
    titleEn: "Refund Policy",
    eyebrowAr: "السياسات القانونية",
    eyebrowEn: "Legal policies",
    updatedAr: updated,
    updatedEn: updatedEn,
    leadAr:
      "تشرح هذه السياسة الحالات التي يحق فيها للعميل استرداد رسوم الاستشارة أو الاشتراك في خدمات مجموعة الدخيل القانونية.",
    leadEn:
      "This policy explains in which cases a client may request a refund of consultation or subscription fees paid to Aldakheel Legal Group.",
    sectionsAr: [
      {
        h: "1. نطاق هذه السياسة",
        p: "تنطبق هذه السياسة على جميع المبالغ المدفوعة عبر الموقع الإلكتروني aldakheellg.com أو القنوات المرتبطة به (واتساب، البريد الإلكتروني، KNET، MyFatoorah، Tap Payments).",
      },
      {
        h: "2. الاستشارة الفردية",
        p: "يحق للعميل طلب استرداد كامل المبلغ خلال 24 ساعة من الحجز شريطة عدم انعقاد الجلسة. بعد انعقاد الجلسة لا يتم استرداد الرسوم.",
      },
      {
        h: "3. الاشتراكات الشهرية والسنوية",
        p: "يمكن إلغاء الاشتراك في أي وقت. الرسوم المدفوعة عن الفترة الحالية غير قابلة للاسترداد، وتظل الخدمة مفعّلة حتى نهاية الفترة المدفوعة.",
      },
      {
        h: "4. صياغة العقود ومراجعة المستندات",
        p: "لا يتم استرداد رسوم العقود/المستندات بعد إصدار النسخة الأولى من المحرر. إذا تم اكتشاف خطأ جوهري من المكتب، يتم تصحيحه مجاناً.",
      },
      {
        h: "5. طريقة طلب الاسترداد",
        p: "أرسل طلب الاسترداد إلى البريد accounts@aldakheellg.com أو عبر واتساب +965 6965 6963 خلال المدة المسموح بها. تُرسَل النتيجة خلال 7 أيام عمل.",
      },
      {
        h: "6. ردّ المبلغ",
        p: "يتم ردّ المبلغ عبر نفس وسيلة الدفع الأصلية. قد يستغرق ظهور المبلغ في حسابك من 3 إلى 10 أيام عمل حسب البنك.",
      },
    ],
    sectionsEn: [
      {
        h: "1. Scope of this policy",
        p: "This policy applies to all payments made through aldakheellg.com or its linked channels (WhatsApp, email, KNET, MyFatoorah, Tap Payments).",
      },
      {
        h: "2. Single consultations",
        p: "A client may request a full refund within 24 hours of booking, provided the session has not yet taken place. Once the session begins, fees are non-refundable.",
      },
      {
        h: "3. Monthly and annual subscriptions",
        p: "You may cancel at any time. Fees paid for the current period are non-refundable, but service remains active until the end of that paid period.",
      },
      {
        h: "4. Contract drafting and document review",
        p: "Fees for contract drafting and document review are non-refundable after the first draft is delivered. If a material error from our side is found, we will correct it free of charge.",
      },
      {
        h: "5. How to request a refund",
        p: "Send a refund request to accounts@aldakheellg.com or via WhatsApp +965 6965 6963 within the permitted window. We respond within 7 business days.",
      },
      {
        h: "6. Method of refund",
        p: "Refunds are issued through the original payment method. It may take 3 to 10 business days for the amount to appear in your account depending on your bank.",
      },
    ],
  },

  "ai-disclaimer": {
    titleAr: "إخلاء مسؤولية الذكاء الاصطناعي",
    titleEn: "AI Disclaimer",
    eyebrowAr: "السياسات القانونية",
    eyebrowEn: "Legal policies",
    updatedAr: updated,
    updatedEn: updatedEn,
    leadAr:
      "أدوات الذكاء الاصطناعي على هذا الموقع — بما في ذلك المستشار سامي، مراجعة المستندات، تقييم القضايا، وصياغة العقود — هي أدوات مساعدة ولا تحلّ محلّ المحامي المرخّص.",
    leadEn:
      "The AI tools on this site — including Sami chat, document review, case assessment, and contract drafting — are assistive tools and do not replace a licensed lawyer.",
    sectionsAr: [
      {
        h: "1. طبيعة الأدوات الذكية",
        p: "يستخدم هذا الموقع نماذج ذكاء اصطناعي متقدمة من Anthropic Claude مدعومة بمكتبة القوانين الكويتية. الأدوات تقدّم معلومات قانونية عامة وليست استشارة قانونية مُلزِمة.",
      },
      {
        h: "2. التحقق من الإحالات",
        p: "نطابق أرقام المواد التي يذكرها المساعد مع النصوص المحفوظة في مكتبتنا كلما أمكن، لكن ذلك لا يضمن خلو الإجابة من الخطأ ولا انطباقها على حالتك بعينها، وتبقى مراجعة المحامي لازمة.",
      },
      {
        h: "3. لا توجد علاقة موكِّل ومحامٍ",
        p: "استخدامك للأدوات الذكية لا ينشئ علاقة موكِّل ومحامٍ بينك وبين مجموعة الدخيل القانونية. لإثبات هذه العلاقة يجب توقيع عقد توكيل رسمي.",
      },
      {
        h: "4. السرية",
        p: "محادثاتك مع سامي والمستندات التي ترفعها تُحفظ بأمان لتحسين الخدمة. لا نبيعها لأي طرف ثالث. اطّلع على سياسة السرية للتفاصيل.",
      },
      {
        h: "5. حدود المسؤولية",
        p: "المجموعة غير مسؤولة عن أي قرار قانوني أو خسارة مالية ناتجة عن الاعتماد الحصري على إجابات الذكاء الاصطناعي دون مراجعة محامٍ مرخّص.",
      },
      {
        h: "6. للحصول على رأي قانوني مُلزِم",
        p: "تواصل مع أحد محامي المجموعة مباشرةً عبر واتساب على +965 6965 6963، وسيُسند إليك ملف رسمي وعقد توكيل وفق القواعد المهنية المعمول بها في الكويت.",
      },
    ],
    sectionsEn: [
      {
        h: "1. Nature of the AI tools",
        p: "This site uses advanced AI models from Anthropic Claude, backed by our Kuwaiti law library. The tools provide general legal information, not binding legal advice.",
      },
      {
        h: "2. Citation checking",
        p: "We check the article numbers the assistant cites against the texts stored in our library wherever possible. This does not guarantee the answer is error-free or that it applies to your case; a lawyer's review is still required.",
      },
      {
        h: "3. No attorney-client relationship",
        p: "Use of the AI tools does NOT create an attorney-client relationship with Aldakheel Legal Group. Such a relationship is established only via a signed engagement contract.",
      },
      {
        h: "4. Confidentiality",
        p: "Your conversations with Sami and any documents you upload are stored securely for service improvement. We do not sell them to third parties. See the Confidentiality Policy for details.",
      },
      {
        h: "5. Limitation of liability",
        p: "The firm is not liable for any legal decision or financial loss arising from sole reliance on AI answers without consulting a licensed lawyer.",
      },
      {
        h: "6. For binding legal advice",
        p: "Contact a lawyer directly via WhatsApp at +965 6965 6963; a licensed lawyer will open a formal file and sign a Power of Attorney under the Kuwait Bar Association rules.",
      },
    ],
  },

  "confidentiality-policy": {
    titleAr: "سياسة السرية وحماية البيانات",
    titleEn: "Confidentiality & Data Protection Policy",
    eyebrowAr: "السياسات القانونية",
    eyebrowEn: "Legal policies",
    updatedAr: updated,
    updatedEn: updatedEn,
    leadAr:
      "السرّ المهني للمحامي حق دستوري في الكويت. هذه السياسة تشرح كيف نحمي بياناتك ومستنداتك ومحادثاتك مع المكتب.",
    leadEn:
      "Attorney-client privilege is a constitutional right in Kuwait. This policy explains how we protect your data, documents, and communications with the firm.",
    sectionsAr: [
      {
        h: "1. البيانات التي نجمعها",
        p: "نجمع: اسمك، بريدك، هاتفك، تفاصيل قضيتك التي ترسلها، المستندات التي ترفعها، ومحادثاتك مع المستشار سامي. لا نجمع معلومات بنكية حساسة (يتم الدفع عبر بوابات معتمدة).",
      },
      {
        h: "2. كيف نستخدم البيانات",
        p: "لتقديم الخدمات القانونية المطلوبة، تحسين الذكاء الاصطناعي، إرسال إشعارات الجلسات، والتواصل معك. لا تُستخدم لأي غرض تسويقي خارج المكتب.",
      },
      {
        h: "3. السرّ المهني للمحامي",
        p: "كل ما تتبادله مع محامي المكتب يخضع للسر المهني وفقاً لقانون المحاماة الكويتي. لا يُكشف لأي طرف إلا بقرار قضائي.",
      },
      {
        h: "4. الأمان التقني",
        p: "البيانات مشفّرة أثناء النقل (HTTPS) والتخزين. كلمات المرور مشفّرة بـ bcrypt. الجلسات محمية بـ HttpOnly cookies + JWT. الوصول الإداري يتطلب 2FA.",
      },
      {
        h: "5. الاحتفاظ بالبيانات",
        p: "نحتفظ بالبيانات طوال فترة العلاقة + 5 سنوات بعدها (لأغراض الإثبات والسجلات المهنية). يحق لك طلب حذف بياناتك بعد انتهاء هذه المدة.",
      },
      {
        h: "6. حقوقك",
        p: "لك الحق في الاطلاع على بياناتك، تعديلها، أو طلب حذفها (بعد المدة القانونية). تواصل مع privacy@aldakheellg.com.",
      },
      {
        h: "7. الإفصاح القانوني",
        p: "قد نُجبَر على الإفصاح عن بياناتك بأمر قضائي صادر عن محكمة كويتية مختصة. سنخطرك في أقصر وقت ممكن.",
      },
    ],
    sectionsEn: [
      {
        h: "1. Data we collect",
        p: "We collect: your name, email, phone, case details you submit, documents you upload, and your chats with Sami. We do NOT collect sensitive bank data (payments are processed via certified gateways).",
      },
      {
        h: "2. How we use your data",
        p: "To deliver the requested legal services, improve our AI, send hearing notifications, and communicate with you. We do not use it for any external marketing.",
      },
      {
        h: "3. Attorney-client privilege",
        p: "Everything you share with a firm lawyer is covered by the attorney-client privilege under the Kuwait Bar Association rules. It is not disclosed except by court order.",
      },
      {
        h: "4. Technical security",
        p: "Data is encrypted in transit (HTTPS) and at rest. Passwords are hashed with bcrypt. Sessions use HttpOnly cookies + JWT. Admin access requires 2FA.",
      },
      {
        h: "5. Data retention",
        p: "We retain data for the relationship duration + 5 years thereafter (for evidentiary and professional-record purposes). After that period, you may request deletion.",
      },
      {
        h: "6. Your rights",
        p: "You may access, correct, or request deletion of your data (after the legal retention period). Contact privacy@aldakheellg.com.",
      },
      {
        h: "7. Legal disclosure",
        p: "We may be compelled to disclose your data by an order from a competent Kuwaiti court. We will notify you as soon as legally possible.",
      },
    ],
  },

  "payment-policy": {
    titleAr: "سياسة الدفع",
    titleEn: "Payment Policy",
    eyebrowAr: "السياسات القانونية",
    eyebrowEn: "Legal policies",
    updatedAr: updated,
    updatedEn: updatedEn,
    leadAr:
      "تشرح هذه السياسة طرق الدفع المعتمدة، العملات، الفوترة، والتعامل مع المعاملات الفاشلة في مجموعة الدخيل القانونية.",
    leadEn:
      "This policy explains accepted payment methods, currencies, invoicing, and how failed transactions are handled at Aldakheel Legal Group.",
    sectionsAr: [
      {
        h: "1. طرق الدفع المقبولة",
        p: "KNET، MyFatoorah، Tap Payments، بطاقات Visa / Mastercard، التحويل البنكي، الدفع عبر واتساب بعد الموافقة على عرض الأسعار.",
      },
      {
        h: "2. العملة",
        p: "جميع الرسوم بالدينار الكويتي (KWD). إذا اخترت الدفع ببطاقة دولية، يتم الصرف وفق سعر بنكك في تاريخ الدفع.",
      },
      {
        h: "3. توقيت الدفع",
        p: "الاستشارة: قبل الجلسة بـ 24 ساعة على الأقل. الاشتراك: بداية الفترة. صياغة العقود: 50% مقدّماً + 50% عند التسليم. القضايا: حسب عقد التوكيل.",
      },
      {
        h: "4. الفواتير",
        p: "نُصدر فاتورة إلكترونية لكل معاملة تصلك على بريدك، وتحمل اسم المكتب وبياناته الرسمية.",
      },
      {
        h: "5. المعاملات الفاشلة",
        p: "إذا فشل الدفع، سيظهر تنبيه فوري على الموقع. إن خُصم المبلغ من حسابك دون تأكيد، تواصل مع accounts@aldakheellg.com وسنحل المشكلة خلال 7 أيام عمل.",
      },
      {
        h: "6. الأمان",
        p: "لا نخزّن بيانات البطاقات على خوادمنا. كل المعاملات تتم عبر بوابات معتمدة من بنك الكويت المركزي وفق PCI-DSS.",
      },
      {
        h: "7. تواصل المحاسبة",
        p: "بريد: accounts@aldakheellg.com — واتساب: +965 6965 6963 — ساعات العمل: الأحد إلى الخميس 9:00 ص – 5:00 م.",
      },
    ],
    sectionsEn: [
      {
        h: "1. Accepted payment methods",
        p: "KNET, MyFatoorah, Tap Payments, Visa / Mastercard cards, bank transfer, and WhatsApp-based payment after quotation approval.",
      },
      {
        h: "2. Currency",
        p: "All fees are in Kuwaiti Dinar (KWD). If you pay with an international card, conversion follows your bank's rate on the payment date.",
      },
      {
        h: "3. Payment timing",
        p: "Consultation: at least 24 hours before the session. Subscription: at the start of the period. Contract drafting: 50% upfront + 50% on delivery. Litigation: per the engagement contract.",
      },
      {
        h: "4. Invoices",
        p: "We issue an electronic invoice for every transaction, emailed to you and carrying the firm's official details.",
      },
      {
        h: "5. Failed transactions",
        p: "If a payment fails, you will see an immediate alert. If the amount was deducted without confirmation, contact accounts@aldakheellg.com and we will resolve it within 7 business days.",
      },
      {
        h: "6. Security",
        p: "We do not store card data on our servers. All transactions go through gateways certified by the Central Bank of Kuwait under PCI-DSS.",
      },
      {
        h: "7. Accounting contact",
        p: "Email: accounts@aldakheellg.com — WhatsApp: +965 6965 6963 — Office hours: Sun–Thu 9:00 AM – 5:00 PM.",
      },
    ],
  },
};
